<template>
  <div>
    <ApprovalItem
      v-for="approval in approvals"
      :key="approval.id"
      :approval="approval"
      :data-testid="`approvalsList-item-approval-${approval.id}`"
      :selected="approval.id === selectedApprovalId"
      @click="$emit('select', approval)"
    />
  </div>
</template>

<script>
import ApprovalItem from './ApprovalItem.vue'

export default {
  name: 'ApprovalsList',

  components: {
    ApprovalItem,
  },

  props: {
    approvals: {
      type: Array,
      default: () => [],
    },
    selectedApprovalId: {
      type: String,
      default: null,
    },
  },
}
</script>
